module.exports = __webpack_public_path__ + "a1316605c472f3c0dae013e08e38564d.jpg";